import { query, request } from 'src/utils/request';

// 同步公务卡
export async function asyncOfficailCard(data) {
  return request('/zlb/api/pay/bankCard/official/sync', {
    method: 'POST',
    data,
  });
}

// 列表展示，条件筛选接口
// https://yapi.cai-inc.com/project/3075/interface/api/320450
export async function fetchOfficialList(data) {
  return request('/zlb/api/pay/bankCard/official/list', {
    method: 'POST',
    data,
  });
}

// 添加公务卡 /zlb/api/pay/bankCard/official/add
// https://yapi.cai-inc.com/project/3075/interface/api/320618
export async function addOfficialCard(data) {
  return request('/zlb/api/pay/bankCard/official/add', {
    method: 'POST',
    data,
  });
}

/**
 * 公务卡绑定
 * 接口文档：https://yapi.cai-inc.com/project/3075/interface/api/275330
 */
export async function bindOfficialCard(data) {
  return request('/zlb/api/pay/bankCard/official/bind', {
    method: 'POST',
    data,
  });
}

/**
 * 获取模版
 */
export async function getTemplate(params) {
  return request('/zlb/api/pay/import/get-template', {
    method: 'GET',
    params,
  });
}

/**
 * 公务卡解绑
 * 接口文档：https://yapi.cai-inc.com/project/3075/interface/api/272914
 */
export async function unbindOfficialCard(data) {
  return request('/zlb/api/pay/bankCard/official/unbind', {
    method: 'POST',
    data,
  });
}

/**
 * 公务卡删除
 * 接口文档：https://yapi.cai-inc.com/project/3075/interface/api/202806
 */
export async function deleteOfficialCard({ accountCode, ...data }) {
  return request(`/zlb/api/pay/bankCard/delete/${accountCode}`, {
    method: 'POST',
    data,
  });
}

/**
 * 查看单个银行账号明文信息
 * 接口文档：https://yapi.cai-inc.com/project/3075/interface/api/205494
 */
export async function reqDetail(params) {
  return request(`/zlb/api/pay/bankCard/detail/${params.accountCode}`);
}

/**
 * 根据持卡人姓名精确查询单位内人员列表
 * 接口文档：https://yapi.cai-inc.com/project/3075/interface/api/322098
 */
export async function searchOperator({ accountName, ...data }) {
  return request(`/zlb/api/pay/bankCard/official/search-operator/${accountName}`, {
    method: 'POST',
    data,
  });
}

// 编辑科目
export const exportOfficialCardList = async data => {
  return query('/zlb/api/pay/bankCard/official/list/export', {
    method: 'post',
    data,
  });
};

// 获取导出结果
export const getOfficialCardExportResult = async params => {
  return query('/zlb/api/pay/bankCard/official/list/export/result', {
    params,
  });
};
